import { render } from "./UserHome.vue?vue&type=template&id=2c79adf1&scoped=true"
import script from "./UserHome.vue?vue&type=script&lang=js"
export * from "./UserHome.vue?vue&type=script&lang=js"

import "./UserHome.vue?vue&type=style&index=0&id=2c79adf1&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2c79adf1"

export default script